// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"e7fa1c2e","455":"868abfbd","644":"c71d32b4","706":"ae1d6ad1","727":"12b25c00","770":"73862448","955":"ae94d083"}[chunkId] + ".chunk.js";
};